export function isInfinite(recoData, threshold) {
    return recoData && (recoData.unviewedRecommendationWrapperList.length + recoData.viewedRecommendationWrapperList.length > threshold);
}